
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {FeedUpdateLevel2SnapshotResponse} from './FeedUpdateLevel2SnapshotResponse';
import {Level2Quotes} from '../core/Level2Quotes';
import {FieldModelLevel2Quotes} from '../core/Level2Quotes';

/**
 * FeedUpdateLevel2SnapshotRequest struct
 */
class FeedUpdateLevel2SnapshotRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!Map=} level2
   * @constructor
   */
  constructor (parent = new Request(), level2 = new Map()) {
    super()
    super.copy(parent)
    this.Level2 = level2
  }

  /**
   * Copy struct (shallow copy)
   * @this {!FeedUpdateLevel2SnapshotRequest}
   * @param {!FeedUpdateLevel2SnapshotRequest} other Other struct
   * @returns {!FeedUpdateLevel2SnapshotRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Level2 != null) {
      this.Level2 = new Map()
      Object.keys(other.Level2).forEach(key => {
        if (key != null) {
          let tempKey
          tempKey = key
          if (other.Level2[key] != null) {
            let tempValue
            tempValue = Level2Quotes.fromObject(other.Level2[key])
            this.Level2.set(tempKey, tempValue)
          } else {
            this.Level2.set(tempKey, null)
          }
        }
      })
    } else {
      this.Level2 = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!FeedUpdateLevel2SnapshotRequest}
   * @returns {!FeedUpdateLevel2SnapshotRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new FeedUpdateLevel2SnapshotRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new FeedUpdateLevel2SnapshotRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!FeedUpdateLevel2SnapshotRequest}
   * @param {!FeedUpdateLevel2SnapshotRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof FeedUpdateLevel2SnapshotRequest)) {
      throw new TypeError('Instance of FeedUpdateLevel2SnapshotRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!FeedUpdateLevel2SnapshotRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Level2: ((this.Level2 != null) ? fbe.MapToObject(new Map(Array.from(this.Level2, item => [((item[0] != null) ? item[0] : null), ((item[1] != null) ? item[1] : null)]))) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return FeedUpdateLevel2SnapshotRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!FeedUpdateLevel2SnapshotRequest} other Object value
   * @returns {!FeedUpdateLevel2SnapshotRequest} Created struct
   */
  static fromObject (other) {
    return new FeedUpdateLevel2SnapshotRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!FeedUpdateLevel2SnapshotRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return FeedUpdateLevel2SnapshotRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!FeedUpdateLevel2SnapshotRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6352
  }
}

export { FeedUpdateLevel2SnapshotRequest };

/**
 * Fast Binary Encoding FeedUpdateLevel2SnapshotRequest field model
 */
class FieldModelFeedUpdateLevel2SnapshotRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.Level2 = new fbe.FieldModelMap(new fbe.FieldModelString(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), new FieldModelLevel2Quotes(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelFeedUpdateLevel2SnapshotRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelFeedUpdateLevel2SnapshotRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelFeedUpdateLevel2SnapshotRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Level2.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelFeedUpdateLevel2SnapshotRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Level2.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelFeedUpdateLevel2SnapshotRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelFeedUpdateLevel2SnapshotRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelFeedUpdateLevel2SnapshotRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6352
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelFeedUpdateLevel2SnapshotRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelFeedUpdateLevel2SnapshotRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Level2.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Level2.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Level2.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelFeedUpdateLevel2SnapshotRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelFeedUpdateLevel2SnapshotRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelFeedUpdateLevel2SnapshotRequest}
   * @param {!FeedUpdateLevel2SnapshotRequest} fbeValue Default value, defaults is new FeedUpdateLevel2SnapshotRequest()
   * @returns {!FeedUpdateLevel2SnapshotRequest} FeedUpdateLevel2SnapshotRequest value
   */
  get (fbeValue = new FeedUpdateLevel2SnapshotRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelFeedUpdateLevel2SnapshotRequest}
   * @param {!FeedUpdateLevel2SnapshotRequest} fbeValue FeedUpdateLevel2SnapshotRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Level2.fbeSize) <= fbeStructSize) {
      this.Level2.get(fbeValue.Level2)
    } else {
      fbeValue.Level2.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Level2.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelFeedUpdateLevel2SnapshotRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelFeedUpdateLevel2SnapshotRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelFeedUpdateLevel2SnapshotRequest}
   * @param {!FeedUpdateLevel2SnapshotRequest} fbeValue FeedUpdateLevel2SnapshotRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelFeedUpdateLevel2SnapshotRequest}
   * @param {FeedUpdateLevel2SnapshotRequest} fbeValue FeedUpdateLevel2SnapshotRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Level2.set(fbeValue.Level2)
  }
}

export { FieldModelFeedUpdateLevel2SnapshotRequest };

/**
 * Fast Binary Encoding FeedUpdateLevel2SnapshotRequest model
 */
class FeedUpdateLevel2SnapshotRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelFeedUpdateLevel2SnapshotRequest(this.buffer, 4)
  }

  /**
   * Get the FeedUpdateLevel2SnapshotRequest model
   * @this {!FeedUpdateLevel2SnapshotRequestModel}
   * @returns {!FieldModelFeedUpdateLevel2SnapshotRequest} model FeedUpdateLevel2SnapshotRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!FeedUpdateLevel2SnapshotRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!FeedUpdateLevel2SnapshotRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return FeedUpdateLevel2SnapshotRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!FeedUpdateLevel2SnapshotRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelFeedUpdateLevel2SnapshotRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!FeedUpdateLevel2SnapshotRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!FeedUpdateLevel2SnapshotRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!FeedUpdateLevel2SnapshotRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!FeedUpdateLevel2SnapshotRequestModel}
   * @param {!FeedUpdateLevel2SnapshotRequest} value FeedUpdateLevel2SnapshotRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!FeedUpdateLevel2SnapshotRequestModel}
   * @param {!FeedUpdateLevel2SnapshotRequest} value FeedUpdateLevel2SnapshotRequest value, defaults is new FeedUpdateLevel2SnapshotRequest()
   * @return {!object} Deserialized FeedUpdateLevel2SnapshotRequest value and its size
   */
  deserialize (value = new FeedUpdateLevel2SnapshotRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new FeedUpdateLevel2SnapshotRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new FeedUpdateLevel2SnapshotRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!FeedUpdateLevel2SnapshotRequestModel}
   * @param {!number} prev Previous FeedUpdateLevel2SnapshotRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { FeedUpdateLevel2SnapshotRequestModel };
FeedUpdateLevel2SnapshotRequest.__has_response = true;
FeedUpdateLevel2SnapshotRequest.__response_class = FeedUpdateLevel2SnapshotResponse;
